<template>
  <main class="main main--has-floating-buttons grid--dense grid--min-height">
    <card :title="$t('admin.pageSwitchHotel.card.customers')" cols="12">
      <hm-card-inner>
        <hm-input-toggle v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" v-model="showDeleted" label="Show deactivated?" cols="12 2@hd start-1"/>
        <hm-input v-model="filter" :label="$t('admin.pageSwitchHotel.filter')" name="filter" cols="12 2@hd start-11@hd 3@desktop start-10@desktop 6@tablet start-7@tablet">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="filter" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(filter)" :border="false" icon="close-text" @click="filter = null" />
          </template>
        </hm-input>
      </hm-card-inner>
      <hm-card-inner :full-size="true">
        <paginated-table :rows="filteredRows"
                         :items-per-page="10"
                         :sticky="true"
                         :hover="true"
                         :columns="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') ? '9' : '7'"
                         min-width="700px">
          <template slot="table-head">
            <div v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" class="hm-table__th">{{ $t('admin.pageSwitchHotel.customers.tenantNumber') }}</div>
            <div v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" class="hm-table__th">{{ $t('admin.pageSwitchHotel.customers.hotelNumber') }}</div>
            <div class="hm-table__th">{{ $t('admin.pageSwitchHotel.customers.uiHotelId') }}</div>
            <div class="hm-table__th">{{ $t('admin.pageSwitchHotel.customers.instanceName') }}</div>
            <div class="hm-table__th">{{ $t('admin.pageSwitchHotel.customers.partner') }}</div>
            <div class="hm-table__th">Country</div>
            <div class="hm-table__th">{{ $t('admin.pageSwitchHotel.customers.roomCount') }}</div>
            <div class="hm-table__th">External Account ID</div>
            <div class="hm-table__th"></div>
          </template>
          <template v-slot:default="slotProps">
            <template v-for="hotel in slotProps.currentPage">
              <div v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td" @click="openHotel(hotel)">{{ hotel.tenantNumber }}</div>
              <div v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td" @click="openHotel(hotel)">{{ hotel.hotelNumber }}</div>
              <div :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td" @click="openHotel(hotel)">{{ hotel.hotelId }}</div>
              <div :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td" @click="openHotel(hotel)">{{ hotel.subdomain }}</div>
              <div :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td" @click="openHotel(hotel)">{{ hotel.whiteLabel }}</div>
              <div :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td" @click="openHotel(hotel)">{{ hotel.countryCode }}</div>
              <div :class="[{'deactivated': hotel.deactivated }, {'text--bold color--red': hotel.roomCount > (hotel.licensedRooms || 0)}]" class="hm-table__td" @click="openHotel(hotel)">{{ hotel.roomCount }} / {{ hotel.licensedRooms || 0 }}</div>
              <div :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td" @click="openHotel(hotel)">{{ hotel.externalAccountId }}</div>
              <div :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td hm-table__td--icon">
                <span v-tooltip="{ title: 'Copy Hotel ID', delay: 0, positionFixed: true, trigger: 'hover', touch: false }" class="quick-action-button" title="Copy Hotel ID" @click="$copy(hotel.hotelId)">
                  <icon icon="copy" />
                </span>
              </div>
              <!--              <div :class="[{'deactivated': hotel.deactivated }]" class="hm-table__td text-right" @click="openHotel(hotel)">{{ hotel.lastLogin | toLocalDateTime }}</div>-->
            </template>
          </template>
        </paginated-table>
      </hm-card-inner>
    </card>


    <hm-floating-buttons ref="floatingButtons">
      <hm-floating-button :disabled="!hasRole('ROLE_SYSADMIN')"
                          label="Add new tenant"
                          icon="plus"
                          color="blue"
                          @click="showCreateTenant" />
    </hm-floating-buttons>
  </main>
</template>


<script>
/* eslint func-names: 0 */

import { isEmpty, isNil, last, isFunction, sortBy, head, lowerCase, orderBy } from 'lodash';
import uuid from 'uuid';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import FilterMixin from '@/mixins/FilterMixin';

export default {
  name: 'PageSwitchHotel',

  mixins: [HotelmeisterMixin, FilterMixin],

  data() {
    return {
      filter: null,
      showDeleted: false,
    };
  },

  computed: {
    hotels: function () {
      return orderBy(this.$store.getters['hotel/hotels'], it => parseInt(it.hotelNumber, 10)).filter(it => this.showDeleted || it.deactivated !== true);
    },
    filteredRows: function () {
      if (isEmpty(this.filter)) return this.hotels;
      return this.hotels.filter(it => Object.values(it).filter(str => !isEmpty(str) && lowerCase(str).indexOf(lowerCase(this.filter)) >= 0).length > 0);
    },
  },

  watch: {
  },

  mounted: function () {
  },

  created: function () {
    this.updateHotels();
  },

  methods: {
    showCreateTenant() {
      this.$router.push({ name: 'createTenant' });
    },
    openHotel(hotel) {
      if (hotel.hotelId === this.$root.hotel) return;

      this.addUIBreadcrumb('User initiated hotel switch');

      const toRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).includes('__hotelSettings')) {
          toRemove.push(localStorage.key(i));
        }
      }
      toRemove.forEach(it => localStorage.removeItem(it));

      // eslint-disable-next-line no-undef
      setToken(hotel.hotelId, getToken(this.$root.hotel));
      // eslint-disable-next-line no-undef
      clearToken(this.$root.hotel);
      // this.$root.hotel = hotel.hotelId;
      this.$store.dispatch('hotel/setHotelId', hotel.hotelId);
      // this.$serviceBus.$emit('hotelSettings.update.immediate');
      // this.$root.logout();

      // eslint-disable-next-line no-undef
      const routeURL = this.$router.resolve({ name: 'hotels', params: { hotelId: hotel.hotelId }, query: { token: getToken(this.$root.hotel) } });
      window.location.href = routeURL.href;
    },
    updateHotels() {
      if (isNil(this.$root.hotel)) {
        this.hotels = [];
        return;
      }

      this.$store.dispatch('hotel/updateAccessibleHotels');
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-table__td {
    &.deactivated {
      color: $gray;
      text-decoration: line-through;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageSwitchHotel.vue